















import {
  createComponent,
  inject,
  onMounted,
  onUnmounted,
  computed,
  watch
} from "@vue/composition-api";
import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import ErrorMessage from "@/components/molecules/ErrorMessage.vue";
import router from '../../router'

export default createComponent({
  setup(props, {emit}) {
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const errorDialog = computed(
      () => displayui.dialogCompanyError
    );

    const companyError = computed(() => company.companyError);
    onUnmounted(() => {
     displayui.closeDialogCompanyError();
    })
    const closeDialogCompanyError = () => {
      displayui.closeDialogCompanyError();
      emit('redirect')
    };

    return {
      errorDialog,
      companyError,
      closeDialogCompanyError
    };
  },
  components: {
    ErrorMessage
  }
});
